import { useState, useRef } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  CircularProgress,
  FormControlLabel,
  RadioGroup,
  Radio,
  Tooltip,
} from "@mui/material";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { motion } from "framer-motion";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckIcon from "@mui/icons-material/Check";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { toast } from "react-toastify";
import { UpsertVMPreRegistrationVisitorAction } from "../../../../../store/Employee/Visitors/Action";
import { v4 as uuidv4 } from "uuid";
import { ConvertDate, getDomain, getUserData } from "../../../Base/helper/baseFunctions";
import { AddEmailTokenHelper } from "../../../Ancillary/EmailToken/helper/EmailTokenHelper";
import { GetVMMultipleOrgConfigurationHelper } from "../../../VisitorSettings/helper/OrgType/OrgTypeHelper";
import {sendWhatsAppTextMessageHelper} from "../../../Whatsapp/helper/TemplateHelper";
import {BASE_URL} from "../../../../Constants/baseConstant";

const PreRegFormFlow = ({
  employeesData,
  handleEmployees,
  handleVisitorReasons,
  visitorReasonData,
  visitorRegData,
  setVisitorRegData = () => { },
  initialValue,
  setMode,
  isSingleOrg
}) => {
  const dispatch = useDispatch();
  // const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  // const whatsAppFlow = atsModuleData?.find((item) => item.module_name === "Whatsapp Flow");
  const whatsAppFlow = false;
  const { whatsappConfigData } = useSelector((state) => state?.AncillaryReducer?.WhatsappConfigReducer);
  
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [sendWhatsappMsg, setSendWhatsappMsg] = useState("no");
  const data= getUserData();

  const [slideMessage, setSlideMessage] = useState(null);
  const { vmPreRegistrationLoading } = useSelector(
    (state) => state?.EmployeeReducer?.VisitorsReducer
  );
 
  const steps = [
    {
      id: "visitors_name",
      label: "Guest Name",
      component: (
        <TextField
          label="Enter Guest Name"
          fullWidth
          variant="standard"
          size="large"
          autoFocus
          value={visitorRegData.visitors_name}
          onChange={(e) => {
            setVisitorRegData((prevData) => ({
              ...prevData,
              visitors_name: e.target.value,
            }));
            setErrors({});
          }}
          error={!!errors.visitors_name}
          helperText={errors.visitors_name || ""}
          FormHelperTextProps={{
            sx: {
              marginTop: "-10px",
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "28px",
              height: "50px",
              marginBottom: "20px",
              "&:before": {
                borderBottom: "2px solid #000",
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid #1976d2",
              },
            },
          }}
          sx={{
            "& .MuiInput-root": {
              fontSize: "28px",
              height: "50px",
              borderBottom: "2px solid black",
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid blue",
              },
            },
            "& .MuiInput-underline:after": {
              borderBottom: "2px solid #1976d2",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
        />
      ),
      validate: () => visitorRegData.visitors_name.trim() !== "",
      show: true,
    },
    {
      id: "phone-number",
      label: "Guest Mobile Number",
      component: (
        <TextField
          label="Enter Mobile Number"
          placeholder="9876543210"
          variant="standard"
          autoFocus
          type="number"
          fullWidth
          value={visitorRegData?.visitors_mobile_no}
          onChange={(e) => {
            if (e.target.value.length <= 10) {
              setVisitorRegData((prevData) => ({
                ...prevData,
                visitors_mobile_no: e.target.value,
              }));
              setErrors({});
            }
          }}
          error={!!errors.visitors_mobile_no}
          helperText={errors.visitors_mobile_no || ""}
          FormHelperTextProps={{
            sx: {
              marginTop: "-10px",
            },
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              fontSize: "28px",
              height: "50px",
              marginBottom: "20px",
              "&:before": {
                borderBottom: "2px solid #000",
              },
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid #1976d2",
              },
            },
          }}
          sx={{
            "& .MuiInput-root": {
              fontSize: "28px",
              height: "50px",
              borderBottom: "2px solid black",
              "&:hover:not(.Mui-disabled):before": {
                borderBottom: "2px solid blue",
              },
            },
            "& .MuiInput-underline:after": {
              borderBottom: "2px solid #1976d2",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
        />
      ),
      validate: () => /^\d{10}$/.test(visitorRegData.visitors_mobile_no),
      show: true,
    },
    {
      id: "booking_date",
      label: "Visit Date",
      component: (
        <CommonDatePicker
          name="booking_date"
          label="Visit Date"
          size="small"
          variant="standard"
          pickerFormat="dd/MM/yyyy"
          DefaultDTvalue={visitorRegData?.booking_date ? new Date(visitorRegData.booking_date) : null}
          handleChange={(value) => {
            const formattedDate = value
              ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
              : "";
            setVisitorRegData((prev) => ({ ...prev, booking_date: formattedDate }));
            setErrors({});
          }}
          autoFocus
          onKeyPress={(e) => e.preventDefault()}
          onKeyDown={(e) => e.preventDefault()}
          error={!!errors.booking_date}
          helperText={errors.booking_date || ""}
          textFieldSx={{
            width: "100%",
            isPreRegistration: true,
            "& .MuiInput-root": {
              fontSize: "28px",
              height: "50px",
              borderBottom: "2px solid black",
              "&:hover": {
                borderBottom: "2px solid black",
              },
              "&.Mui-focused": {
                borderBottom: "2px solid black",
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
        />
      ),
      validate: () => !!visitorRegData.booking_date,
      show: true,
    },
    {
      id: "person-to-meet",
      label: "Host/Person to Meet",
      component: (
        <SelectableSearch
          label="Select Person"
          value={visitorRegData?.employee_id}
          loading={() => handleEmployees()}
          fieldLabel="name"
          variant={"outlined"}
          name="employee_id"
          size="small"
          onChangeEvent={(e, v) => {
            setVisitorRegData((prev) => ({ ...prev, [e]: v }));
            setErrors({});
          }}
          data={employeesData}
          error={!!errors.employee_id}
          helperText={errors.employee_id || ""}
          styles={{
            "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
              border: "none",
              borderBottom: "2px solid black",
              borderRadius: 0,
              fontSize: "28px",
              height: "50px",
              marginTop: "5px"
            },
            "& .MuiOutlinedInput-notchedOutline, & fieldset": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-root, &:hover .MuiInputBase-root": {
              borderBottom: "2px solid black",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
          renderOption={(props, option) => (
            <li {...props} style={{ fontSize: "18px", padding: "5px 15px" }}>
              {option.name}
            </li>
          )}
        />
      ),
      validate: () => visitorRegData?.employee_id,
      show: true,
    },
    {
      id: "purpose-of-visit",
      label: "Purpose of Visit",
      component: (
        <SelectableSearch
          label="Select Purpose"
          value={visitorRegData?.visitors_management_reasons_pk}
          loading={() => handleVisitorReasons()}
          fieldLabel="reason"
          variant={"outlined"}
          name="visitors_management_reasons_pk"
          size="small"
          onChangeEvent={(e, v) => {
            setVisitorRegData((prev) => ({ ...prev, [e]: v }));
            setErrors({});
          }}
          data={visitorReasonData}
          error={!!errors.visitors_management_reasons_pk}
          helperText={errors.visitors_management_reasons_pk || ""}
          styles={{
            "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
              border: "none",
              borderBottom: "2px solid black",
              borderRadius: 0,
              fontSize: "28px",
              height: "50px",
              marginTop: "5px"
            },
            "& .MuiOutlinedInput-notchedOutline, & fieldset": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-root, &:hover .MuiInputBase-root": {
              borderBottom: "2px solid black",
            },
            "& .MuiInputLabel-root": {
              fontSize: "26px",
            },
          }}
          renderOption={(props, option) => (
            <li {...props} style={{ fontSize: "18px", padding: "5px 15px" }}>
              {option.reason}
            </li>
          )}
        />
      ),
      validate: () => visitorRegData?.visitors_management_reasons_pk,
      show: true,
    },
  ];
  const filteredSteps = steps?.filter((step) => step?.show);

  const validateStep = () => {
    let newErrors = {};
    const currentStepId = filteredSteps[step]?.id;
    switch (currentStepId) {
      case "visitors_name":
        if (!visitorRegData.visitors_name.trim()) {
          newErrors.visitors_name = "Name is required.";
        } else if (/^\d+$/.test(visitorRegData.visitors_name.trim())) {
          newErrors.visitors_name = "Name can't contain only numbers.";
        }
        break;
      case "phone-number":
        if (!/^\d{10}$/.test(visitorRegData.visitors_mobile_no)) {
          newErrors.visitors_mobile_no = "Enter a valid 10-digit phone number.";
        }
        break;
      case "person-to-meet":
        if (!visitorRegData.employee_id) {
          newErrors.employee_id = "Please select a person to meet.";
        }
        break;
      case "org":
        if (!visitorRegData.multiple_org_configuration_pk) {
          newErrors.multiple_org_configuration_pk = "Please select an organization.";
        }
        break;
      case "purpose-of-visit":
        if (!visitorRegData.visitors_management_reasons_pk) {
          newErrors.visitors_management_reasons_pk = "Please select a purpose.";
        }
        break;
      case "booking_date":
        if (!visitorRegData.booking_date) {
          newErrors.booking_date = "Visit Date is required.";
        }
        break;
      default:
        break;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleResetForm = () => {
    setVisitorRegData(initialValue);
    setSlideMessage(null);
    setSendWhatsappMsg("no");
  };

  const handleWhatsappRadioChange = (e) => {
    const val = e.target.value;
    if (val === "yes") {
      const configObj = whatsappConfigData?.[0] || {};
      const rawPhone = configObj?.whatsapp_business_number || "";
      let cleanPhone = String(rawPhone).replace(/[^0-9]/g, "");
      if (!cleanPhone) {
        toast.dismiss()
        toast.error("WhatsApp phone number is not configured. Please configure it under Settings > General > Configuration.");
        setSendWhatsappMsg("no");
        return;
      }
    }
    setSendWhatsappMsg(val);
  };

  const handleSendWhatsappInvite = async (token, infoData) => {
    try {
      const passUrl = `${BASE_URL}/vm-guestpass-download-portal?${token}`;
      const hostName = infoData?.employee_id?.name || "-";
      const visitDate = infoData?.booking_date ? ConvertDate(infoData?.booking_date) : "-";
      const visitorName = infoData?.visitors_name || "Guest";
      const mobileNo = infoData?.visitors_mobile_no;
      if(!mobileNo) {
        toast.error("Mobile number is missing.")
        return
      }
      const messageText = `Hi ${visitorName},\n\nYour visit has been pre-registered successfully.\n\nVisit Date: ${visitDate}\nHost: ${hostName}\n\nTo access your Check-In QR Pass, please click the link below:\n${passUrl}\n\nYou can download and show the QR pass at the entry gate during check-in.\n\npowered by Meepl`;

      sendWhatsAppTextMessageHelper({
        number: mobileNo,
        message: messageText,
        preview_url: true,
        show: true
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleNext = () => {
    if (!validateStep()) return;
    const currentStep = filteredSteps[step];
    const currentLabel = currentStep?.label;
    const currentValue = (() => {
      switch (currentStep?.id) {
        case "visitors_name":
          return visitorRegData?.visitors_name || "";
        case "phone-number":
          return visitorRegData?.visitors_mobile_no || "";
        case "person-to-meet":
          return visitorRegData?.employee_id?.name || "";
        case "purpose-of-visit":
          return visitorRegData?.visitors_management_reasons_pk?.reason || "";
        case "booking_date": {
          const bookingDate = visitorRegData?.booking_date ? new Date(visitorRegData.booking_date) : null;
          return bookingDate ? bookingDate.toLocaleDateString() : "";
        }
        case "org":
          return visitorRegData?.multiple_org_configuration_pk?.org_name || "";
        default:
          return "";
      }
    })();

    setSlideMessage(null);
    setTimeout(() => {
      setSlideMessage(`${currentLabel} : ${currentValue}`);
    }, 10);

    if (step < filteredSteps.length - 1) {
      setStep(step + 1);
    } else {
      let isAdd = !visitorRegData?.pre_registration_visitors_pk
      let token = isAdd ? uuidv4() + `=${getDomain()}=guest-token` : visitorRegData?.visitor_reason_comment;
      dispatch(
        UpsertVMPreRegistrationVisitorAction(
          {
            ...visitorRegData,
            visited_employee_email: visitorRegData?.employee_id?.office_email,
            visitor_reason_fk: visitorRegData?.visitors_management_reasons_pk?.visitors_management_reasons_pk,
            visitor_reason_comment: isAdd ? token : visitorRegData?.visitor_reason_comment,
            multiple_org_configuration_pk: visitorRegData?.pre_registration_visitors_pk ? visitorRegData?.multiple_org_configuration_fk : isSingleOrg ? null : data?.multiple_org_configuration || null 
          },
          async (result, error) => {
            if (!error && result?.data?.statuscode === 200) {  
                  let multiple_org_configuration = null;
                  if(!isSingleOrg) {
                    const res = await GetVMMultipleOrgConfigurationHelper();
                    if (res?.data?.statuscode === 200) {
                      const resData = res?.data?.data
                      const id = visitorRegData?.pre_registration_visitors_pk ? visitorRegData?.multiple_org_configuration_fk : data?.multiple_org_configuration;
                      const findData = resData?.filter((el) => +el.multiple_org_configuration_pk === +id );
                      multiple_org_configuration = findData?.length ? findData?.[0] : null 
                    }
                  } 
                  AddEmailTokenHelper({
                        token: token,
                        json_data: JSON.stringify([
                        {...visitorRegData,
                            employee_id : {
                                name : visitorRegData?.employee_id?.name,
                                employee_id : visitorRegData?.employee_id?.emp_users_pk || "",
                                office_email : visitorRegData?.employee_id?.office_email,
                                whatsapp_phone_no : visitorRegData?.employee_id?.whatsapp_phone_no
                            },
                            multiple_org_configuration_fk: multiple_org_configuration
                        }]),
                    });
                  if (sendWhatsappMsg === "yes") {
                    handleSendWhatsappInvite(token, visitorRegData);
                  }
                  handleResetForm();
                  setMode("grid");
            } else {
              toast.error("Something went wrong");
            }
          }
        )
      );
    }
  };
  const handleBack = () => {
    if (step > 0) {
      setStep(step - 1);
      setSlideMessage(null);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "500px",
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "120px",
        textAlign: "center",
      }}
    >
      <Box marginTop={"-50px"}>
        <Typography variant="h4" gutterBottom>
          {filteredSteps[step].label}
        </Typography>
      </Box>
      <Box>
        <Box
          sx={{
            minHeight: "100px",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "-70px",
          }}
        >
          {slideMessage && (
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 2 }}
              style={{
                position: "absolute",
                top: "-45px",
                left: "0px",
                transform: "translateX(-50%)",
                backgroundColor: "rgb(204, 211, 224)",
                color: "black",
                padding: "10px 16px",
                borderRadius: "6px",
                fontSize: "16px",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                zIndex: 10,
                whiteSpace: "nowrap",
                pointerEvents: "none",
              }}
            >
              {slideMessage}
            </motion.div>
          )}
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            style={{
              position: "absolute",
              width: "100%",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleNext();
            }}
          >
            {filteredSteps[step].component}
          </motion.div>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            gap: "20px",
          }}
        >
          {filteredSteps[step]?.id === "phone-number" && whatsAppFlow && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "14px", color: "#444" }}>
                Send WhatsApp Invite:
              </Typography>
              <Tooltip title="Send Visitor Pass & Check-In QR link to the guest via WhatsApp" arrow>
                <InfoOutlinedIcon sx={{ fontSize: "18px", color: "#666", cursor: "pointer", mr: 0.5 }} />
              </Tooltip>
              <RadioGroup
                row
                value={sendWhatsappMsg}
                onChange={handleWhatsappRadioChange}
                sx={{ gap: "4px" }}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio size="small" sx={{ p: 0.5, "&.Mui-checked": { color: "#fecb03" } }} />}
                  label={<Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Yes</Typography>}
                  sx={{ mr: 1, ml: 0 }}
                />
                <FormControlLabel
                  value="no"
                  control={<Radio size="small" sx={{ p: 0.5, "&.Mui-checked": { color: "#fecb03" } }} />}
                  label={<Typography sx={{ fontSize: "14px", fontWeight: 500 }}>No</Typography>}
                  sx={{ mr: 0, ml: 0 }}
                />
              </RadioGroup>
            </Box>
          )}
          <Button
            onClick={handleBack}
            disabled={step === 0}
            variant="contained"
            sx={{
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px",
              backgroundColor: "#fecb03",
              visibility: step === 0 ? "hidden" : "visible",
              minWidth: "unset",
              "&:hover": {
                backgroundColor: "#fecb03",
              },
            }}
          >
            <ArrowForwardIosIcon
              sx={{
                fontSize: "28px",
                color: "black",
                transform: "rotate(180deg)",
              }}
            />
          </Button>
          <Button
            onClick={() => !vmPreRegistrationLoading && handleNext()}
            variant="contained"
            sx={{
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "12px",
              backgroundColor: "#fecb03",
              minWidth: "unset",
              "&:hover": {
                backgroundColor: "#fecb03",
              },
            }}
          >
            {step < filteredSteps.length - 1 ? (
              <ArrowForwardIosIcon sx={{ fontSize: "28px", color: "black" }} />
            ) : (
              <>
                {vmPreRegistrationLoading ? (
                  <CircularProgress size={28} sx={{ color: "black" }} />
                ) : (
                  <CheckIcon sx={{ fontSize: "32px", color: "black" }} />
                )}{" "}
              </>
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PreRegFormFlow;
